import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={props.width}
    height={props.height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.7 11.406H7.453a.376.376 0 0 1-.375-.375V8.573H4.922v2.458a.376.376 0 0 1-.375.375H2.3a.376.376 0 0 1-.375-.375V6.42H.375a.375.375 0 0 1-.267-.637L5.733.11a.378.378 0 0 1 .534 0l5.625 5.674a.373.373 0 0 1-.267.637h-1.55v4.61a.376.376 0 0 1-.375.375Z"
      fill={props.color}
    />
  </svg>
);

export default SvgComponent;
